const TopBar = {
	flipVisible: false,
};

export default {
	TopBar,
};
